<template>
    <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
        <div class="modal-header d-flex justify-content-center pt-1">
            <h5 class="modal-title text-center">{{ empresaNome }}</h5>
        </div>

        <div class="modal-body">
            <b-card bg-variant="light">
                <b-form @keyup.enter="handleSubmit">
                    <b-row class="mb-3">
                        <b-col>
                            <lg-form-input id="codigoSearch" v-model="codigoSearch" placeholder="Código CNAE" />
                        </b-col>

                        <b-col>
                            <lg-form-input id="descricaoSearch" v-model="descricaoSearch" placeholder="Descrição" />
                        </b-col>

                        <b-col>
                            <lg-form-const-select @change="load()" v-model="principalFilter" id="principal"
                                :options="optionsFilterPrincipal" />
                        </b-col>

                        <b-col>
                            <b-form-group class="b-form-group-styled d-flex align-items-center">
                                <b-button id="localizarCnae" @click="load" class="ml-2" size="sm" pill variant="primary"
                                    style="height: 20px;">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="localizarCnae" title="Localizar" triggers="hover"></b-tooltip>
                                </b-button>

                                <b-button id="limpaCnae" class="ml-2" size="sm" pill variant="primary" @click="limpar"
                                    style="height: 20px;">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" />
                                    </div>
                                    <b-tooltip target="limpaCnae" title="Limpar" triggers="hover"></b-tooltip>
                                </b-button>

                                <b-button v-if="temPrivilegioCadastro()" class="ml-2" pill id="addCnae"
                                    variant="primary" size="sm" @click="addCnae" style="height: 20px;">
                                    <div class="btn-size-alinhamento">
                                        <b-icon scale="2" icon="plus" />
                                    </div>
                                </b-button>
                                <b-tooltip target="addCnae" title="Adicionar novo..." triggers="hover"></b-tooltip>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
                <b-table :items="this.records" :fields="fields" responsive="sm" striped :hover="true" :busy="busy"
                    show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template #cell(acoes)="{ item }">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-button :disabled="!temPrivilegioEdicao()" id="editar" class="my-2 mx-1" size="sm" pill
                                variant="primary" @click="ModalEditar(item)">
                                <b-icon icon="pencil-square" />
                                <b-tooltip target="editar" title="Editar..." triggers="hover"></b-tooltip>
                            </b-button>

                            <b-button v-if="item.principal" variant="success" class="my-2 mx-2" size="sm"
                                :id="'principal-icon-' + item.id">
                                <b-icon icon="check-circle" />
                                <b-tooltip :target="'principal-icon-' + item.id" title="CNAE principal"
                                    triggers="hover"></b-tooltip>
                            </b-button>

                            <b-button :disabled="!temPrivilegioEdicao()" id="excluir" class="my-2 mx-1" size="sm" pill
                                variant="danger" @click="excluirCnae(item)">
                                <b-icon icon="trash" />
                                <b-tooltip target="excluir" title="Excluir..." triggers="hover"></b-tooltip>
                            </b-button>
                        </div>
                    </template>
                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
                <ModalCnaeAdicionar v-if="showModalAdicionar" :codEmpresa="codEmpresa" :prefix="updatedPrefix"
                    @fechar="fechar" :id="idEdit" />
            </b-card>
        </div>
    </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import ModalCnaeAdicionar from "@/core/components/Modals/ModalCnaeAdicionar.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        ModalCnaeAdicionar,
    },
    data() {
        return {
            idEdit: null,
            showModal: true,
            showModalAdicionar: false,
            busy: false,
            codigoSearch: "",
            descricaoSearch: "",
            principalFilter: null,
            optionsFilterPrincipal: [
                { text: "Todos", value: null },
                { text: "Principal", value: true },
                { text: "Secundário", value: false },
            ],
            fields: [
                {
                    key: "codigo",
                    label: "Código CNAE",
                    tdClass: "px-3",
                },
                {
                    key: "descricao",
                    label: "Descrição",
                    tdClass: "px-3",
                },
                { key: "acoes", label: "" },
            ],
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/empresacnae`);
    },
    mounted() {
        this.load();
    },
    props: {
        prefix: Array,
        empresaNome: String,
        codEmpresa: Number,
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "CNAE"];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
    },
    watch: {
        page() {
            this.load()
        },
    },

    methods: {
        temPrivilegioCadastro() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);
        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);
        },

        ModalEditar(item) {
            this.idEdit = item.id;
            this.showModalAdicionar = true;
        },
        handleSubmit(event) {
            event.preventDefault();
            this.load();
        },
        closeModal() {
            this.showModal = false;
        },
        async load() {
            this.busy = true;
            var filtro = {};

            filtro.codEmpresa = this.codEmpresa;

            if (this.codigoSearch) {
                filtro.codigo = this.codigoSearch;
            }
            if (this.descricaoSearch) {
                filtro.descricao = this.descricaoSearch;
            }
            if (this.principalFilter !== null) {
                filtro.principal = this.principalFilter;
            }

            await this.$loadResource({
                limit: this.perPage,
                page: this.page,
                params: filtro,
            });
            this.busy = false;
        },
        addCnae() {
            this.showModalAdicionar = true;
        },
        limpar() {
            this.codigoSearch = "";
            this.descricaoSearch = "";
            this.principalFilter = null;
            this.load();
        },
        cancelar() {
            this.$emit("close");
        },
        fechar() {
            this.showModalAdicionar = false;
            this.idEdit = null;
            this.load();
        },
        async excluirCnae(item) {
            let response = await this.$confirm(
                "Deseja excluir este CNAE?",
                `${item.codigo} - ${item.descricao}`
            )
            if (response) {
                try {
                    await this.$service.remove(item.id);
                    this.$notify({
                        type: "success",
                        message: "CNAE excluído com sucesso!"
                    });
                    this.load();
                } catch (e) {
                    this.$notify({
                        type: "danger",
                        message: "Erro ao excluir o CNAE!"
                    });
                }
            }
        }
    },
};
</script>

<style scoped>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    padding-top: 1rem;
}

.table-header {
    margin-bottom: 1rem;
}

.b-table td,
.b-table th {
    vertical-align: middle;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
